import React from 'react';
import { useTranslation } from 'react-i18next';

import { VIDEO_EXPLICATIVO_URL, VIDEO_DIFUSION_URL } from '../videos';

function VideoLink(props) {
  return (
    <a className={props.buttonClassName} href={props.url} target="_blank" rel="noopener noreferrer">
      <i className="fab fa-youtube"></i>&nbsp;&nbsp;{props.label}
    </a>
  );
}

/**
 * The two IAPRL videos, side by side on wide screens and stacked on narrow ones.
 * @param {string} buttonClassName button styling, which differs between the light desktop
 * card and the coloured mobile background
 */
export default function VideoLinks(props) {
  const { t } = useTranslation();
  return (
    <div className="row justify-content-center no-gutters">
      <div className="col-12 col-sm-6 p-2 text-center">
        <VideoLink
          url={VIDEO_EXPLICATIVO_URL}
          label={t('dashboard::Explanatory video')}
          buttonClassName={props.buttonClassName}
        />
      </div>
      <div className="col-12 col-sm-6 p-2 text-center">
        <VideoLink
          url={VIDEO_DIFUSION_URL}
          label={t('dashboard::Outreach video')}
          buttonClassName={props.buttonClassName}
        />
      </div>
    </div>
  );
}
